import React, { useContext, useEffect, useRef, useState } from "react";
import { firebase } from "../constants/firebase";
import { PopupContext } from "../containers/Popup";
import { Comment } from "./Comment";

const LIMIT = 5;

export const CommentList = ({ setInputProps }) => {
  const [comments, setComments] = useState([]);
  const [skip, setSkip] = useState(0);
  const { thread } = useContext(PopupContext);

  const db = firebase.firestore();
  const first = useRef(null);

  useEffect(() => {
    if (!comments.length && thread) {
      first.current = db
        .collection("comments")
        .where("thread", "==", db.doc(`/threads/${thread}`))
        .orderBy("createdAt", "desc")
        .limit(LIMIT);
      first.current.onSnapshot((snapshot) => {
        if (!snapshot.empty) {
          setComments(
            snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
          );
        }
      });
    }
  }, [comments, thread, db]);

  useEffect(() => {
    if (first.current && thread) {
      first.current.get().then((documentSnapshots) => {
        // Get the last visible document
        const lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];

        if (lastVisible) {
          first.current = db
            .collection("comments")
            .where("thread", "==", db.doc(`/threads/${thread}`))
            .orderBy("createdAt", "desc")
            .startAfter(lastVisible)
            .limit(LIMIT);

          first.current.onSnapshot((snapshot) => {
            if (!snapshot.empty) {
              setComments([
                ...comments,
                ...snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })),
              ]);
            }
          });
        }
      });
    }
  }, [skip, db]);

  if (!comments || !comments.length) {
    return <div> No Comments Yet!</div>;
  }

  return (
    <div className="d-flex flex-grow flex-column justify-content-start h-2/3 overflow-auto">
      {comments.map((comment) => (
        <Comment
          key={comment.id}
          comment={comment}
          setInputProps={setInputProps}
        />
      ))}

      {comments.length >= 5 && (
        <div className="w-full text-center mb-2">
          <button
            type="button"
            className="mx-auto text-gray-400 transition ease-in duration-200 text-center text-base underline hover:text-gray-300"
            onClick={(e) => setSkip(skip + LIMIT)}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};
